var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTimeGray1818 = function SvgTimeGray1818(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DEE0E1",
    d: "M9 .667C4.408.667.667 4.408.667 9S4.408 17.333 9 17.333 17.333 13.592 17.333 9 13.592.667 9 .667m3.625 11.308a.62.62 0 0 1-.858.217L9.183 10.65c-.642-.383-1.117-1.225-1.117-1.967V5.267a.63.63 0 0 1 .625-.625.63.63 0 0 1 .625.625v3.416c0 .3.25.742.509.892l2.583 1.542c.3.175.4.558.217.858"
  })));
};
export default SvgTimeGray1818;